import {Component, OnDestroy, OnInit} from '@angular/core';
import {Subscription} from 'rxjs';
import {environment} from '../../environments/environment';
import {BrandThemeService} from '../shared/brand-theme.service';

@Component({
  standalone: false,
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit, OnDestroy {
  brand = {
    name: 'Marketplace',
    accentColor: '#2563eb',
    logoUrl: ''
  };
  currentYear = new Date().getFullYear();
  private themeSub?: Subscription;
  private imagesBaseUrl = '';

  get brandInitial(): string {
    return (this.brand.name || 'M').trim().charAt(0).toUpperCase();
  }

  get logoSrc(): string {
    return this.brandThemeService.resolveMediaUrl(this.brand.logoUrl, this.imagesBaseUrl);
  }

  constructor(private brandThemeService: BrandThemeService) {}

  ngOnInit(): void {
    environment.then(env => {
      this.imagesBaseUrl = env['images'] || '';
      if (env['brand']) {
        this.brand = {...this.brand, ...env['brand']};
      }
    });
    this.themeSub = this.brandThemeService.theme$.subscribe(theme => {
      this.brand = {
        ...this.brand,
        name: theme.marketplaceName || this.brand.name,
        accentColor: theme.fontColor,
        logoUrl: theme.logoUrl || '',
      };
    });
    this.brandThemeService.ensureLoaded().subscribe();
  }

  ngOnDestroy(): void {
    this.themeSub?.unsubscribe();
  }
}
